import React, { useState } from 'react';
import './Reviews.css';

export default function Reviews({ eyebrow, title, reviews, sectionId, orderTarget }) {
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ name: '', rating: '5', message: '' });
  const [submitted, setSubmitted] = useState(false);

  function handleChange(e) {
    const { name, value } = e.target;
    setForm((prev) => ({ ...prev, [name]: value }));
  }

  function handleSubmit(e) {
    e.preventDefault();
    if (!form.name.trim() || !form.message.trim()) return;
    setSubmitted(true);
    setForm({ name: '', rating: '5', message: '' });
    setTimeout(() => setSubmitted(false), 3000);
  }

  return (
    <section className="reviews-section" id={sectionId}>
      <span className="section-eyebrow">{eyebrow}</span>
      <h2 className="section-title">{title}</h2>

      <div className="review-actions">
        <button
          type="button"
          className="review-action-btn review-action-btn--buy"
          onClick={() => document.getElementById(orderTarget?.replace('#', ''))?.scrollIntoView({ behavior: 'smooth' })}
        >
          Buy Now
        </button>
        <button
          type="button"
          className="review-action-btn review-action-btn--post"
          onClick={() => setShowForm((prev) => !prev)}
        >
          {showForm ? 'Hide Review Form' : 'Post a Review'}
        </button>
      </div>

      {showForm && (
        <form className="review-form" onSubmit={handleSubmit}>
          <div className="review-form-row">
            <div className="review-form-group">
              <label htmlFor={`${sectionId}-name`}>Name</label>
              <input
                id={`${sectionId}-name`}
                name="name"
                value={form.name}
                onChange={handleChange}
                placeholder="Your name"
              />
            </div>
            <div className="review-form-group">
              <label htmlFor={`${sectionId}-rating`}>Rating</label>
              <select
                id={`${sectionId}-rating`}
                name="rating"
                value={form.rating}
                onChange={handleChange}
              >
                {[5, 4, 3, 2, 1].map((value) => (
                  <option key={value} value={value}>{value} Stars</option>
                ))}
              </select>
            </div>
          </div>
          <div className="review-form-group">
            <label htmlFor={`${sectionId}-message`}>Review</label>
            <textarea
              id={`${sectionId}-message`}
              name="message"
              rows="4"
              value={form.message}
              onChange={handleChange}
              placeholder="Share your experience..."
            />
          </div>
          <button type="submit" className="review-submit-btn">
            Submit Review
          </button>
          {submitted && <p className="review-submit-success">Thank you — your review has been submitted!</p>}
        </form>
      )}

      <div className="review-grid">
        {reviews.map((review) => (
          <div className="review-card" key={`${review.name}-${review.location}`}>
            <div className="stars">{'★'.repeat(review.stars)}</div>
            <p className="review-text">{review.text}</p>
            <div className="review-author">
              <div className="review-avatar">{review.avatar}</div>
              <div>
                <div className="review-name">{review.name}</div>
                <div className="review-loc">{review.location}</div>
              </div>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}
